export { default as createInfiniteHitsSessionStorageCache } from "./sessionStorage.js";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-instantsearch-dom/dist/es/lib/infiniteHitsCache/index.js
// module id = 664
// module chunks = 1